export default __webpack_public_path__ + "static/media/add-printer.dcb7dc6d.svg";